import {createStore, combineReducers, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
/////////////////////////////
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // usa localStorage por defecto
/////////////////////////////
import userReducer from './UsersDucks'
import tareasV2Reducer from './TareasV2Ducks'
import tabReducer from './TabDucks'
import generalReducer from './GeneralDuck'
import { getWindowId } from '../Utilities/WindowId';
import contratoReducer from './V2/ContratoRedux'
import firmaReducer from './V2/FirmaRedux'
import tagsReducer from './V2/TagsRedux'


const windowId = getWindowId();
const persistConfig = {
    //key: 'root',
    key: `persistedState-${windowId}`, // 👈 evita compartir clave entre pestañas
    storage,
  }

const rootReducer = combineReducers({
    users : userReducer,
    tareasV2 : tareasV2Reducer,
    tab: tabReducer,
    general: generalReducer,
    contratoV2: contratoReducer,
    firmaV2: firmaReducer,
    tags: tagsReducer
})


const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
})

const persistor = persistStore(store)

export { store, persistor }

/*
export default function generateStore() {
    const store = createStore( rootReducer, composeWithDevTools( applyMiddleware(thunk) ) )
    return store
}*/